export default {
  DASHBOARD: {
    path: '/',
    name: 'dashboard',
    meta: {
      requiresAuth: true,
      main: true
    },
    component: () => import('@ps_views/DashBoard.vue')
  },
  SURVEYS: {
    path: '/surveys',
    name: 'surveys',
    meta: {
      requiresAuth: true,
      apps: ['bitburst']
    },
    component: () => import('@ps_views/resources/Surveys/index'),
    props: true
  },
  SURVEY_DETAILS: {
    path: '/survey/:surveyId',
    name: 'survey_details',
    meta: {
      requiresAuth: true,
      quickLink: true,
      models: ['survey'],
      title: 'Survey Details',
      order: 0,
      main: true,
      apps: ['bitburst']
    },
    component: () => import('@ps_views/resources/Surveys/Detail'),
    props: (route) => ({
      ...route.params
    })
  },
  TOGGLE_APP_SURVEY: {
    type: 'function',
    path: 'toggle_app_survey',
    name: 'toggle_app_survey',
    permission: 'toggle_app_survey',
    meta: {
      requiresAuth: true
    }
  },
  PUBLISHERS: {
    path: '/publishers',
    name: 'publishers',
    meta: {
      requiresAuth: true,
      apps: ['bitburst']
    },
    component: () => import('@ps_views/Publishers.vue')
  },
  PUBLISHER_DETAILS: {
    path: '/publisher/:publisherId',
    name: 'publisher_details',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/publishers/SurveyPublisherDetails.vue')
  },
  QUALIFICATIONS: {
    path: '/qualifications',
    name: 'qualifications',
    meta: {
      requiresAuth: true,
      quickLink: true,
      project: 'ps',
      models: ['user', 'survey'],
      title: 'Qualifications',
      order: 5,
      apps: ['bitburst']
    },
    component: () => import('@ps_views/resources/Qualifications'),
    props: true
  },
  APPS: {
    path: '/apps',
    name: 'apps',
    meta: {
      requiresAuth: true,
      apps: ['bitburst']
    },
    component: () => import('@ps_views/resources/Apps')
  },
  APP_DETAILS: {
    path: '/apps/:appId',
    name: 'app_details',
    meta: {
      requiresAuth: true,
      apps: ['bitburst']
    },
    component: () => import('@ps_views/apps/AppDetails.vue')
  },
  BITBURST_APPS: {
    path: '/bitburst-apps',
    name: 'bitburst_apps',
    meta: {
      requiresAuth: true,
      apps: ['bitburst']
    },
    component: () => import('@ps_views/resources/BitburstApps')
  },
  BITBURST_APP_DETAILS: {
    path: '/bitburst-apps/:appId',
    name: 'bitburst_app_details',
    meta: {
      requiresAuth: true,
      apps: ['bitburst']
    },
    component: () => import('@ps_views/resources/BitburstApps/BitburstAppDetails.vue')
  },
  PAYMENTS: {
    path: '/payments',
    name: 'payments',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/Payments.vue')
  },
  STATISTICS: {
    path: '/statistics',
    name: 'statistics',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/Statistics.vue')
  },
  USER_ID_CONVERTER: {
    path: '/user-id-converter',
    name: 'user_id_converter',
    meta: {
      requiresAuth: true,
      loading: false,
      title: 'User ID Converter',
      apps: ['bitburst']
    },
    also_visible_for_permissions: ['users'],
    component: () => import('@ps_views/tools/UserIdConverter.vue')
  },
  USERS: {
    path: '/users',
    name: 'users',
    meta: {
      requiresAuth: true,
      apps: ['bitburst']
    },
    component: () => import('@ps_views/users')
  },
  USER_BULK_ACTIONS: {
    path: '/users/bulk-actions',
    name: 'user_bulk_actions',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/users/BulkActions.vue')
  },
  USER_BULK_DELETE: {
    path: '/users/bulk-delete',
    name: 'user_bulk_delete',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/users/BulkDelete.vue')
  },
  REVIEW_USER: {
    path: '/review-user',
    name: 'review_user',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/resources/Users/ReviewUser')
  },
  USER_DETAILS: {
    path: '/user/:userId',
    name: 'user_details',
    meta: {
      requiresAuth: true,
      quickLink: true,
      project: 'ps',
      title: 'User Details',
      order: 0,
      main: true,
      apps: ['bitburst']
    },
    component: () => import('@ps_views/users/UserDetailsRoute.vue')
  },
  REQUIRE_FACETEC_VERIFICATION: {
    type: 'function',
    path: 'require_facetec_verification',
    name: 'require_facetec_verification',
    permission: 'require_facetec_verification',
    meta: {
      requiresAuth: true
    }
  },
  LOGIN: {
    path: '/login',
    name: 'page-login',
    meta: {
      redirectOnLogin: true,
      loading: false,
      layout: 'full'
    },
    component: () => import('@ps_views/pages/Login.vue')
  },
  TWO_FACTOR_AUTH: {
    path: '/auth/two-factor',
    name: 'auth-two-factor',
    component: () => import('@/views/pages/TwoFactor.vue'),
    meta: { layout: 'full' }
  },
  REGISTER: {
    path: '/register',
    name: 'page-register',
    meta: {
      loading: false,
      layout: 'full'
    },
    component: () => import('@ps_views/pages/Register.vue')
  },
  PAGE_ERROR_404: {
    path: '/error-404',
    name: 'page-error-404',
    meta: {
      loading: false,
      layout: 'full'
    },
    component: () => import('@ps_views/pages/Error404.vue')
  },
  OTHER_PAGES: {
    path: '*',
    redirect: '/error-404'
  },
  FEEDBACK: {
    path: '/feedback',
    name: 'feedback',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/Feedback.vue')
  },
  CHAT: {
    path: '/chat',
    name: 'chat',
    meta: {
      requiresAuth: true,
      quickLink: true,
      project: 'ps',
      title: 'Chats',
      order: 7,
      queryChatFilters: {
        status: ['open', 'snoozed', 'closed'],
        by_user_id: true
      }
    },
    component: () => import('@ps_views/chat/Chat')
  },
  MANAGE_MACROS: {
    type: 'function',
    path: 'manage_macros',
    name: 'manage_macros',
    permission: 'manage_macros',
    meta: {
      requiresAuth: true
    }
  },
  PERFORMANCE_REPORT: {
    path: '/report/performance',
    name: 'performance_report',
    meta: {
      requiresAuth: true,
      apps: ['bitburst']
    },
    component: () => import('@ps_views/report/PerformanceReport.vue')
  },
  QUALIFICATION_REPORT: {
    path: '/report/qualification',
    name: 'qualification_report',
    meta: {
      requiresAuth: true,
      apps: ['bitburst']
    },
    component: () => import('@ps_views/report/QualificationReport.vue')
  },
  AB_TESTS: {
    path: '/ab-tests',
    name: 'ab_tests',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/resources/AbTests')
  },
  CLAIMS_OVERVIEW: {
    path: '/claims-overview',
    name: 'claims_overview',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/claims_overview')
  },
  ADMIN_DASHBOARD: {
    path: '/admin/dashboard',
    name: 'admin_dashboard',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/admin/Dashboard/Index.vue')
  },
  ADMIN_ALERT_SYSTEM: {
    path: '/alert-system',
    name: 'admin_alert_system',
    meta: {
      requiresAuth: true,
      apps: ['bitburst']
    },
    component: () => import('@ps_views/admin/AlertSystem/Index.vue')
  },
  TRUEFACE_ALERT_SYSTEM: {
    path: '/trueface-alert-system',
    name: 'trueface_alert_system',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/admin/TruefaceAlertSystem/Index.vue')
  },
  TRUEFACE_USER_VERIFICATIONS: {
    path: '/trueface-user-verifications',
    name: 'trueface_user_verifications',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/admin/TruefaceUserVerifications/index.vue')
  },
  DAILY_OVERVIEW: {
    path: '/daily-overview',
    name: 'daily_overview',
    meta: {
      requiresAuth: true,
      apps: ['bitburst']
    },
    component: () => import('@ps_views/report/DailyOverview.vue')
  },
  DAILY_SURVEY_SYNC: {
    path: '/daily-survey-sync',
    name: 'daily_survey_sync',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/report/DailySurveySync.vue')
  },
  RESPONSE_STATUS: {
    path: '/response-status',
    name: 'response_status',
    meta: {
      requiresAuth: true,
      apps: ['bitburst']
    },
    component: () => import('@ps_views/resources/ResponseStatus/index.vue')
  },
  RECONCILIATION_PACING: {
    path: '/reconciliation-pacing',
    name: 'reconciliation_pacing',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/resources/ReconciliationPacing/index.vue')
  },
  SURVEY_INVITATIONS: {
    path: '/survey-invitations',
    name: 'survey_invitations',
    showFunction: 'isShowSurveyEntryLinksLog',
    meta: {
      requiresAuth: true,
      quickLink: true,
      models: ['survey'],
      title: 'Entry Link Logs',
      order: 10
    },
    component: () => import('@ps_views/survey/SurveyInvitations.vue'),
    props: true
  },
  SURVEY_INVENTORY: {
    path: '/survey-inventory',
    name: 'survey_inventory',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/survey/SurveyInventory.vue'),
    props: true
  },
  RESPONSE_STATUS_STATISTICS: {
    path: '/response-status-statistics',
    name: 'response_status_statistics',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/report/ResponseStatusStatistics.vue'),
    props: true
  },
  TOP_SURVEYS: {
    path: '/top-surveys',
    name: 'top_surveys',
    meta: {
      requiresAuth: true,
      apps: ['bitburst']
    },
    component: () => import('@ps_views/survey/TopSurveys.vue'),
    props: true
  },
  BITBURST_COMPARISON: {
    path: '/bitburst-comparison',
    name: 'bitburst_comparison',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/report/BitBurstComparison.vue'),
    props: true
  },
  JOB_MONITORING: {
    path: '/job-monitoring',
    name: 'job_monitoring',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/JobMonitoring'),
    props: true
  },
  SUPPLIER_STATEMENT: {
    path: '/supplier-statement',
    name: 'supplier_statement',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/suppliers/SupplierStatement.vue'),
    props: true
  },
  TEAM_ACTIVITY: {
    path: '/team-activity',
    name: 'team_activity',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/TeamActivity/TeamActivityHeatmap.vue'),
    props: true
  },
  TEAM_ACTIVITY_SUMMARY: {
    path: '/team-activity-summary',
    name: 'team_activity_summary',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/TeamActivity/TeamActivitySummary.vue'),
    props: true
  },
  ADJUST_SPEND_APPS: {
    path: '/adjust-spend-apps',
    name: 'adjust_spend_apps',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/resources/AdjustSpend/Apps.vue'),
    props: true
  },
  ADD_EDIT_ADJUST_SPEND_APPS: {
    type: 'function',
    path: 'add-edit-adjust-spend-apps',
    name: 'add_edit_adjust_spend_apps',
    permission: 'add_edit_adjust_spend_apps',
    meta: {
      requiresAuth: true
    }
  },
  ADJUST_SPEND_NETWORKS: {
    path: '/adjust-spend-networks',
    name: 'adjust_spend_networks',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/resources/AdjustSpend/Networks.vue'),
    props: true
  },
  ADD_EDIT_ADJUST_SPEND_NETWORKS: {
    type: 'function',
    path: 'add-edit-adjust-spend-networks',
    name: 'add_edit_adjust_spend_networks',
    permission: 'add_edit_adjust_spend_networks',
    meta: {
      requiresAuth: true
    }
  },
  ADJUST_SPEND_DATA: {
    path: '/adjust-spend-data',
    name: 'adjust_spend_data',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/resources/AdjustSpend/Data.vue'),
    props: true
  },
  IMPORT_ADJUST_SPEND_DATA: {
    type: 'function',
    path: 'import-adjust-spend-data',
    name: 'import_adjust_spend_data',
    permission: 'import_adjust_spend_data',
    meta: {
      requiresAuth: true
    }
  },
  DB_MONITORING: {
    path: '/db-monitoring',
    name: 'db_monitoring',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/db_monitoring'),
    props: true
  },
  REWARDS_LIABILITY: {
    path: '/rewards-liability',
    name: 'rewards_liability_report',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/report/RewardsLiability.vue'),
    props: true
  },
  SURVEY_ATTACKS: {
    path: '/survey-attacks',
    name: 'survey_attacks',
    meta: {
      requiresAuth: true,
      apps: ['bitburst']
    },
    component: () => import('@ps_views/survey/SurveyAttacks.vue'),
    props: true
  },
  FRAUD_REVIEW_STATISTICS: {
    path: '/fraud-review-statistics',
    name: 'fraud_review_statistics',
    meta: {
      requiresAuth: true,
      apps: ['bitburst']
    },
    component: () => import('@ps_views/fraud/FraudReviewStatistics.vue'),
    props: true
  },
  FRAUD_RECONCILIATION_DASHBOARD: {
    path: '/fraud-reconciliation-dashboard',
    name: 'fraud_reconciliation_dashboard',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/report/FraudReconciliationDashboard.vue')
  },
  ACTIVITY_BREAKDOWN: {
    path: '/activity-breakdown',
    name: 'activity_breakdown',
    meta: {
      requiresAuth: true,
      apps: ['bitburst']
    },
    component: () => import('@ps_views/activity_breakdown'),
    props: true
  },
  GEO_MAPPING: {
    path: '/geo-mapping',
    name: 'geo_mapping',
    meta: {
      requiresAuth: true,
      apps: ['bitburst']
    },
    component: () => import('@ps_views/resources/GeoMapping')
  },
  LATENCY_LOGS: {
    path: '/latency-logs',
    name: 'latency_logs',
    meta: {
      requiresAuth: true,
      apps: ['bitburst']
    },
    component: () => import('@ps_views/resources/LatencyLog')
  },
  USER_BAN_STATISTICS: {
    path: '/user-ban-statistics',
    name: 'user_ban_statistics',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/report/UserBanStatistics.vue'),
    props: true
  },
  DELIVERY_OVERVIEW: {
    path: '/delivery-overview',
    name: 'delivery_overview',
    meta: {
      requiresAuth: true
    },
    component: () => import('@/views/report/DeliveryOverview.vue')
  },
  DEVICE_RESULTS: {
    path: '/device-results',
    name: 'device_results',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/resources/DeviceResults'),
    props: true
  },
  TIMEZONE_RESULTS: {
    path: '/timezone-results',
    name: 'timezone_results',
    meta: {
      requiresAuth: true,
      apps: ['bitburst']
    },
    component: () => import('@ps_views/resources/TimezoneResults'),
    props: true
  },
  QUEUE_ALERT_SYSTEM: {
    path: '/queue-alert-system',
    name: 'queue_alert_system',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/resources/QueueAlertSystem')
  },
  SUPPORT_PERFORMANCE: {
    path: '/support-performance',
    name: 'support_performance',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/report/SupportPerformance.vue'),
    props: true
  },
  USER_PROFILING_SEARCH: {
    path: '/user-profiling-search',
    name: 'user_profiling_search',
    meta: {
      requiresAuth: true,
      apps: ['bitburst']
    },
    component: () => import('@ps_views/resources/UserProfiling/UserProfilingSearch.vue'),
    props: true
  },
  SUPPLIER_TOP_SURVEYS: {
    path: '/supplier-top-surveys',
    name: 'supplier_top_surveys',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/survey/SupplierTopSurveys.vue'),
    props: true
  },
  CINT_IMPORTS: {
    path: '/cint-imports',
    name: 'cint_imports',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/resources/CintImports'),
    props: true
  },
  POSTBACK_LOGS: {
    path: '/postback-logs',
    name: 'postback_logs',
    meta: {
      requiresAuth: true,
      apps: ['bitburst']
    },
    component: () => import('@ps_views/resources/PostbackLog')
  },
  POSTBACK_REPLAYS: {
    path: '/postback-replays',
    name: 'postback_replays',
    meta: {
      requiresAuth: true,
      apps: ['bitburst']
    },
    component: () => import('@ps_views/resources/PostbackReplay')
  },
  IP_LOG: {
    path: '/ip-logs',
    name: 'ip_logs',
    meta: {
      requiresAuth: true,
      quickLink: true,
      project: 'ps',
      title: 'IP Logs',
      queryFilterObject: true,
      order: 8,
      apps: ['bitburst']
    },
    component: () => import('@ps_views/resources/IpLogs'),
    props: true
  },
  ADMIN_LOG: {
    path: '/admin-logs',
    name: 'admin_logs',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/resources/AdminLogs'),
    props: true
  },
  IPLOGSONE: {
    path: '/iplogsone',
    name: 'iplogsone',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/resources/IpLogsOne/index'),
    props: true
  },
  IPLOGSTWO: {
    path: '/iplogstwo',
    name: 'iplogstwo',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/resources/IpLogsTwo/index'),
    props: true
  },
  IPLOGSTHREE: {
    path: '/iplogsthree',
    name: 'iplogsthree',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/resources/IpLogsThree/index'),
    props: true
  },
  RECONCILIATION_CHART: {
    path: '/reconciliation-chart',
    name: 'reconciliation_chart',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/report/ReconciliationChart.vue')
  },
  PUBLISHER_TRANSACTIONS: {
    path: '/publisher-transactions',
    name: 'publisher_transactions',
    meta: {
      requiresAuth: true,
      quickLink: true,
      project: 'ps',
      models: ['user'],
      title: 'Transactions'
    },
    component: () => import('@ps_views/resources/PublisherTransactions')
  },
  PUBLISHER_PAYMENTS: {
    path: '/publisher-payments',
    name: 'publisher_payments',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/resources/PublisherPayments')
  },
  APP_OVERVIEW: {
    path: '/app-overview',
    name: 'app_overview',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/apps/AppOverview.vue')
  },
  SINGLE_SURVEY_LINKS: {
    path: '/single-survey-links',
    name: 'single_survey_links',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/survey/SingleSurveyLinks')
  },
  PUBLISHER_PERFORMANCE: {
    path: '/publisher-performance',
    name: 'publisher_performance',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/resources/PublisherPerformance')
  },
  APP_PERFORMANCE: {
    path: '/app-performance',
    name: 'app_performance',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/resources/AppPerformance')
  },
  APP_SUPPLIER_SETTINGS: {
    path: '/app-supplier-settings',
    name: 'app_supplier_settings',
    meta: {
      requiresAuth: true,
      apps: ['bitburst']
    },
    component: () => import('@ps_views/app_supplier_settings')
  },
  PRIME_SAMPLE_BUYERS: {
    path: '/prime-sample-buyers',
    name: 'prime_sample_buyers',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/prime_sample/Buyers')
  },
  COMPLETES_REPORT: {
    path: '/report/completes',
    name: 'completes_report',
    meta: {
      requiresAuth: true,
      apps: ['bitburst']
    },
    component: () => import('@ps_views/report/CompletesReport.vue')
  },
  DYNATA_TOP_SURVEYS: {
    path: '/dynata-top-surveys',
    name: 'dynata_top_surveys',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/survey/DynataTopSurveys.vue')
  },
  FINANCIAL_REPORT: {
    path: '/financial-report',
    name: 'financial_report',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/prime_opinion/Financials')
  },
  SUPPLIER_STATISTICS: {
    path: '/supplier-statistics',
    name: 'supplier_statistics',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/suppliers/SupplierStatistics.vue')
  },
  SURVEY_LIST_RELOAD_STATISTICS: {
    path: '/survey-list-reload-statistics',
    name: 'survey_list_reload_statistics',
    meta: {
      requiresAuth: true,
      title: 'Survey List Reload Statistics'
    },
    component: () => import('@ps_views/SurveyListReloadStatistics.vue')
  },
  CRONJOB_LOGS: {
    path: '/cronjob-logs',
    name: 'cronjob_logs',
    meta: {
      requiresAuth: true,
      apps: ['bitburst']
    },
    component: () => import('@ps_views/resources/CronjobLogs')
  },
  MULTI_SEARCH_USER: {
    path: '/multi-search-users',
    name: 'multi_search_users',
    meta: {
      requiresAuth: true,
      apps: ['bitburst']
    },
    component: () => import('@ps_views/users/MultiSearchUser.vue'),
    props: true
  },
  SEARCH_CLAIMS: {
    path: '/search-claims',
    name: 'search_claims',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/users/SearchClaims.vue'),
    props: true
  },
  BONUS_SCHEDULES: {
    path: '/bonus-schedules',
    name: 'bonus_schedules',
    meta: {
      requiresAuth: true,
      apps: ['bitburst']
    },
    component: () => import('@ps_views/resources/BonusSchedules'),
    props: true
  },
  MULTI_SEARCH_CLICK: {
    path: '/multi-search-clicks',
    name: 'multi_search_clicks',
    meta: {
      requiresAuth: true,
      apps: ['bitburst']
    },
    component: () => import('@ps_views/clicks/MultiSearchClick'),
    props: true
  },
  OFFER_CLICK_SEARCH: {
    path: '/offer-click-search',
    name: 'offer_click_search',
    meta: {
      requiresAuth: true,
      apps: ['bitburst']
    },
    component: () => import('@ps_views/resources/Offers/Clicks/Search.vue'),
    props: true
  },
  CLICK_ID_SEARCH: {
    path: '/click-id-search',
    name: 'click_id_search',
    meta: {
      requiresAuth: true,
      apps: ['bitburst']
    },
    component: () => import('@ps_views/resources/Offers/Clicks/ClickIdSearch.vue'),
    props: true
  },
  RECONCILIATION_REPORT: {
    path: '/report/reconciliation',
    name: 'reconciliation_report',
    meta: {
      requiresAuth: true,
      apps: ['bitburst']
    },
    component: () => import('@ps_views/report/ReconciliationReport.vue')
  },
  SUPPLIERS: {
    path: '/suppliers',
    name: 'suppliers',
    meta: {
      requiresAuth: true,
      apps: ['bitburst']
    },
    component: () => import('@ps_views/Suppliers.vue')
  },
  SUPPLIER_DETAILS: {
    path: '/supplier/:supplierId',
    name: 'supplier_details',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/suppliers/SupplierDetails.vue'),
    props: (route) => ({
      ...route.params
    })
  },
  SUPPLIER_BUYERS: {
    path: '/supplier-buyers',
    name: 'supplier_buyers',
    meta: {
      requiresAuth: true,
      apps: ['bitburst']
    },
    component: () => import('@ps_views/supplier_buyers/SupplierBuyersIndex.vue')
  },
  RESPONDENT_BUYER_BANS: {
    path: '/respondent-buyer-bans',
    name: 'respondent_buyer_bans',
    meta: {
      requiresAuth: true,
      apps: ['bitburst']
    },
    component: () => import('@ps_views/respondent_buyer_bans/Index.vue')
  },
  BITBURST_SUPPLIER_BUYERS: {
    path: '/bitburst-supplier-buyers',
    name: 'bitburst_supplier_buyers',
    meta: {
      requiresAuth: true,
      apps: ['bitburst']
    },
    component: () => import('@ps_views/supplier_buyers/BitburstSupplierBuyers.vue')
  },
  SUPPLIER_BUYER_DETAILS: {
    path: '/supplier-buyer/:supplierBuyerId',
    name: 'supplier_buyer_details',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/supplier_buyers/SupplierBuyerDetails.vue'),
    props: (route) => ({
      ...route.params
    })
  },
  QUESTION_DETAILS: {
    path: '/questions/:questionId',
    name: 'question_details',
    meta: {
      requiresAuth: true,
      apps: ['bitburst']
    },
    component: () => import('@ps_views/qualification_questions/Details.vue'),
    props: (route) => ({
      ...route.params
    })
  },
  QUESTIONS: {
    path: '/questions',
    name: 'questions',
    meta: {
      requiresAuth: true,
      apps: ['bitburst']
    },
    component: () => import('@ps_views/QualificationQuestions.vue')
  },
  QUESTIONS_MAPPING: {
    path: '/questions-mapping',
    name: 'questions_mapping',
    meta: {
      requiresAuth: true,
      apps: ['bitburst']
    },
    component: () => import('@ps_views/questions_mapping/QuestionsMapping.vue')
  },
  PROFILER_DEFAULT_QUESTIONS: {
    path: '/profiler-default-questions',
    name: 'profiler_default_questions',
    meta: {
      requiresAuth: true,
      apps: ['bitburst']
    },
    component: () => import('@ps_views/ProfilerDefaultQuestions/Index.vue')
  },
  SURVEY_PUBLISHERS: {
    path: '/survey-publishers',
    name: 'survey_publishers',
    meta: {
      requiresAuth: true,
      apps: ['bitburst']
    },
    component: () => import('@ps_views/resources/survey_publishers/Index.vue')
  },
  QUESTIONS_MAPPING_STORE: {
    path: '/questions-mapping/add',
    name: 'questions_mapping_add',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/questions_mapping/EditorQuestionsMapping.vue')
  },
  QUESTIONS_MAPPING_DETAILS: {
    path: '/questions-mapping/:questionMappingId',
    name: 'questions_mapping_details',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/questions_mapping/EditorQuestionsMapping.vue')
  },
  QUESTIONS_MAPPING_COPY: {
    path: '/questions-mapping/:questionMappingId/copy/:targetCountryCode',
    name: 'questions_mapping_copy',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/questions_mapping/EditorQuestionsMapping.vue')
  },
  AGE_QUESTIONS: {
    path: '/age-questions',
    name: 'age_questions',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/AgeQuestions')
  },
  ADMINS: {
    path: '/admins',
    name: 'admins',
    meta: {
      requiresAuth: true,
      apps: ['bitburst']
    },
    component: () => import('@ps_views/Admins.vue')
  },
  FEATURE_FLAGS: {
    path: '/feature-flags',
    name: 'feature_flags',
    meta: {
      requiresAuth: true,
      strictPermission: 'internal.feature_flags.manage'
    },
    component: () => import('@ps_views/admin/FeatureFlags/Index.vue')
  },
  FEATURE_FLAGS_CREATE: {
    path: '/feature-flags/new',
    name: 'feature_flags_create',
    meta: {
      requiresAuth: true,
      strictPermission: 'internal.feature_flags.manage'
    },
    component: () => import('@ps_views/admin/FeatureFlags/Editor.vue')
  },
  FEATURE_FLAGS_DETAIL: {
    path: '/feature-flags/:flagKey',
    name: 'feature_flags_detail',
    meta: {
      requiresAuth: true,
      strictPermission: 'internal.feature_flags.manage'
    },
    component: () => import('@ps_views/admin/FeatureFlags/Editor.vue'),
    props: true
  },
  HOME_CONTACTS: {
    path: '/home-contacts',
    name: 'home_contacts',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/HomeContacts.vue')
  },
  SURVEY_GROUPS: {
    path: '/survey-groups',
    name: 'survey_groups',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/SurveyGroups.vue')
  },
  CONFIGS: {
    path: '/configs',
    name: 'configs',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/configs/Configs.vue')
  },
  MANAGE_HIGH_RISK_COUNTRIES: {
    path: '/configs/high-risk-countries',
    name: 'manage_high_risk_countries',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/configs/HighRiskCountries.vue')
  },
  CHAT_SETTINGS: {
    path: '/chat/settings',
    name: 'chat_settings',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/chat/ChatSettings.vue')
  },
  SURVEY_LIST_RELOADS: {
    path: '/survey-list-reloads',
    name: 'survey_list_reloads',
    meta: {
      requiresAuth: true,
      quickLink: true,
      project: 'ps',
      title: 'Survey List Reload Log',
      order: 4
    },
    component: () => import('@ps_views/SurveyListReloads.vue')
  },
  USER_REVIEWS: {
    path: '/user-reviews',
    name: 'user_reviews',
    meta: {
      requiresAuth: true,
      apps: ['bitburst']
    },
    component: () => import('@ps_views/users/UserReviews')
  },
  USER_STATUS_CHANGES: {
    path: '/user-status-changes',
    name: 'user_status_changes',
    meta: {
      requiresAuth: true,
      apps: ['bitburst']
    },
    component: () => import('@ps_views/users/UserStatusChanges.vue')
  },
  USER_STATUS_CHANGES_NEW: {
    path: '/user-status-changes-new',
    name: 'user_status_changes_new',
    meta: {
      requiresAuth: true,
      apps: ['bitburst']
    },
    component: () => import('@ps_views/users/UserStatusChangesNew.vue')
  },
  SURVEY_ATTACKS_OPEN_ENDS: {
    path: '/survey-attacks-open-ends',
    name: 'survey_attacks_open_ends',
    meta: {
      requiresAuth: true,
      apps: ['bitburst']
    },
    component: () => import('@ps_views/survey/SurveyAttacksOpenEnds.vue')
  },
  APP_COUNTRY_SOURCE_CONFIG: {
    path: '/app-country-source-config',
    name: 'app_country_source_config',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/app_country_source_config')
  },
  SUPPORT_USER_REVIEWS: {
    path: '/support-user-reviews',
    name: 'support_user_reviews',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/support/UserReviews.vue')
  },
  USER_FILTER_SEARCH: {
    path: '/user-filter-search',
    name: 'user_filter_search',
    meta: {
      requiresAuth: true,
      apps: ['bitburst']
    },
    component: () => import('@ps_views/users/UserFilterSearch.vue')
  },
  USERS_BY_SOURCE: {
    path: '/users-by-source',
    name: 'users_by_source',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/users/UsersBySource.vue')
  },
  DEV_LOGS: {
    path: '/dev-logs',
    name: 'dev_logs',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/DevLogs.vue')
  },
  SHELL_LOGS: {
    path: '/shell-logs',
    name: 'shell_logs',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/ShellLogs.vue')
  },
  SYSTEM_LOGS: {
    path: '/system-logs',
    name: 'system_logs',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/resources/SystemLogs')
  },
  RECONCILIATION_LOGS: {
    path: '/reconciliation-logs',
    name: 'reconciliation_logs',
    meta: {
      requiresAuth: true,
      apps: ['bitburst']
    },
    component: () => import('@ps_views/resources/ReconciliationLogs')
  },
  CLICKS: {
    path: '/clicks/:clickId?',
    name: 'clicks',
    meta: {
      requiresAuth: true,
      quickLink: true,
      project: 'ps',
      models: ['user', 'survey'],
      title: 'Clicks',
      order: 1,
      apps: ['bitburst']
    },
    component: () => import('@ps_views/resources/Clicks'),
    props: true
  },
  CLICK_TICKETS: {
    path: '/click-tickets',
    name: 'click_tickets',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/ClickTickets.vue')
  },
  CLICKS_BREAKDOWN: {
    type: 'function',
    path: 'showClicksBreakdownModal',
    name: 'clicks_breakdown',
    permission: 'clicks',
    meta: {
      requiresAuth: true,
      quickLink: true,
      models: ['survey'],
      title: 'Breakdown',
      order: 2
    }
  },
  COMPLETES: {
    path: '/completes',
    name: 'completes',
    meta: {
      requiresAuth: true,
      quickLink: true,
      project: 'ps',
      models: ['user', 'survey'],
      title: 'Completes',
      order: 2,
      apps: ['bitburst']
    },
    component: () => import('@ps_views/resources/Completes'),
    props: true
  },
  USER_PROFILINGS: {
    path: '/user-profilings',
    name: 'user_profilings',
    meta: {
      requiresAuth: true,
      quickLink: true,
      project: 'ps',
      title: 'Profiling',
      order: 3,
      apps: ['bitburst']
    },
    component: () => import('@ps_views/users/UserProfilings.vue')
  },
  BASIC_PROFILINGS: {
    type: 'function',
    path: 'showUserProfilingBasicsModal',
    name: 'user_basic_profilings',
    permission: 'user_profilings',
    meta: {
      requiresAuth: true,
      quickLink: true,
      project: 'ps',
      title: 'Basic Profiling',
      order: 4
    }
  },
  SOURCE_EXTENSION: {
    path: '/source-extension',
    name: 'source_extension',
    meta: {
      requiresAuth: true,
      quickLink: true,
      project: 'ps',
      models: ['user', 'survey'],
      title: 'Extension Log',
      order: 7
    },
    component: () => import('@ps_views/extensions/SourceExtensionRedirect.vue')
  },
  SYSTEM_ALERTS: {
    path: '/system-alerts',
    name: 'system_alerts',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/resources/SystemAlerts')
  },
  ROUTER_LOGS: {
    path: '/router-logs',
    name: 'router_logs',
    meta: {
      requiresAuth: true,
      quickLink: true,
      project: 'ps',
      models: ['user', 'survey'],
      title: 'Router Log',
      order: 9,
      queryFilterObject: true,
      apps: ['bitburst']
    },
    component: () => import('@ps_views/RouterLogs.vue')
  },
  RESEARCH_DEFENDER_LOG: {
    path: '/research-defender-log',
    name: 'research_defender_log',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/ResearchDefenderLog.vue')
  },
  CINT_DELIVERY_SHARE: {
    path: '/cint-delivery-share',
    name: 'cint_delivery_share',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/cint_delivery_share')
  },
  CHAT_DASHBOARD: {
    path: '/chat-dashboard',
    name: 'chat_dashboard',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/chat/Dashboard.vue')
  },
  SUPPORT_DASHBOARD: {
    path: '/support-dashboard',
    name: 'support_dashboard',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/support/Dashboard.vue')
  },
  JOB_LOGS: {
    path: '/job-logs',
    name: 'job_logs',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/JobLog')
  },
  FIND_DATA: {
    path: '/find-data',
    name: 'find_data',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/find_data')
  },
  CHAT_WEEKLY_PRODUCTIVITY: {
    path: '/chat-weekly-productivity',
    name: 'chat_weekly_productivity',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/chat/WeeklyProductivity.vue')
  },
  SUPPORT_WEEKLY_PRODUCTIVITY: {
    path: '/support-weekly-productivity',
    name: 'support_weekly_productivity',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/support/WeeklyProductivity.vue')
  },
  CHAT_WEEKLY_CUSTOMER_SATISFACTION: {
    path: '/chat-weekly-csat',
    name: 'chat_weekly_csat',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/chat/WeeklyCustomerSatisfaction.vue')
  },
  CHAT_FIRST_RESPONSE_TIME: {
    path: '/chat-first-response-time',
    name: 'chat_first_response_time',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/chat/ChatFirstResponseTime.vue')
  },
  CHAT_SERVICE_OVERVIEW: {
    path: '/chat-service-overview',
    name: 'chat_service_overview',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/chat/CustomerServiceOverview.vue')
  },
  USER_PROFILING_LOOKUP: {
    path: '/user-profiling-lookup',
    name: 'user_profiling_lookup',
    meta: {
      requiresAuth: true,
      apps: ['bitburst']
    },
    component: () => import('@ps_views/resources/UserProfiling/UserProfilingLookup.vue')
  },
  SURVEY_ATTACKS_APPS: {
    path: '/survey-attacks-apps',
    name: 'survey_attacks_apps',
    meta: {
      requiresAuth: true,
      apps: ['bitburst']
    },
    component: () => import('@ps_views/survey/SurveyAttacksApps.vue')
  },
  CLICK_TICKET_PRODUCTIVITY: {
    path: '/click-ticket-productivity',
    name: 'click_ticket_productivity',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/report/ClickTicketProductivity.vue')
  },
  USER_BONUS_OFFERS: {
    path: '/user-bonus-offers',
    name: 'user_bonus_offers',
    meta: {
      requiresAuth: true,
      quickLink: true,
      project: 'ps',
      models: ['user'],
      title: 'Bonus Offers'
    },
    component: () => import('@ps_views/resources/UserBonusOffers')
  },
  MISSED_OPPORTUNITIES: {
    path: '/missed-opportunities',
    name: 'missed_opportunities',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/report/MissedOpportunities.vue')
  },
  PUBLISHER_API_REQUEST_LOG: {
    path: '/publisher-api-request-log',
    name: 'publisher_api_request_log',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/resources/PublisherApiRequestLog')
  },
  MASTER_REPORT: {
    path: '/master-report',
    name: 'master_report',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/report/MasterReport.vue')
  },
  GAME_LIST: {
    path: '/offer-games',
    name: 'offer_games',
    meta: {
      requiresAuth: true
    },
    component: () => import('@/views/resources/Offers/Games/List')
  },
  OFFER_LIST: {
    path: '/offer-list',
    name: 'offer_list',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/resources/Offers/List')
  },
  OFFER_PROFIT_LIST: {
    path: '/offer-profit-list',
    name: 'offer_profit_list',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/resources/Offers/ProfitList')
  },
  OFFER_DETAILS: {
    path: '/offer/:offerId',
    name: 'offer_details',
    meta: {
      requiresAuth: true,
      quickLink: true,
      project: 'ps',
      models: ['offer'],
      title: 'Offer',
      order: 0,
      main: true
    },
    component: () => import('@ps_views/resources/Offers/List/OfferDetails.vue')
  },
  ADD_EDIT_OFFER: {
    type: 'function',
    path: 'add-edit-offer',
    name: 'add_edit_offer',
    permission: 'add_edit_offer',
    meta: {
      requiresAuth: true
    }
  },
  OFFER_CLICKS: {
    path: '/offer-clicks',
    name: 'offer_clicks',
    meta: {
      requiresAuth: true,
      quickLink: true,
      project: 'ps',
      models: ['offer', 'user'],
      title: 'Offer Clicks'
    },
    component: () => import('@ps_views/resources/Offers/Clicks')
  },
  BLOCK_OFFER_CLICKS: {
    path: '/block-offer-clicks',
    name: 'offer_clicks_block',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/resources/Offers/BlockClicks.vue')
  },
  PUBLISHER_OFFER_SETTINGS: {
    path: '/publisher-offer-settings',
    name: 'publisher_offer_settings',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/publishers/PublisherOfferSettings.vue')
  },
  PUBLISHER_OFFER_SETTINGS_DETAIL: {
    path: '/publisher-offer-settings/:publisherId',
    name: 'publisher_offer_settings_detail',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/publishers/PublisherOfferSettingsDetail.vue')
  },
  OFFER_EVENTS: {
    path: '/offer-events',
    name: 'offer_events',
    meta: {
      requiresAuth: true,
      quickLink: true,
      project: 'ps',
      models: ['offer', 'user'],
      title: 'Offer Events'
    },
    component: () => import('@ps_views/resources/Offers/Events')
  },
  LOTTERIES: {
    path: '/lotteries',
    name: 'lotteries',
    meta: {
      requiresAuth: true,
      title: 'Lottery'
    },
    component: () => import('@ps_views/resources/Lotteries')
  },
  OFFER_BULK_RECONCILIATION: {
    path: '/offer-bulk-reconciliation',
    name: 'offer_bulk_reconciliation',
    meta: {
      requiresAuth: true,
      project: 'ps',
      title: 'Offer Bulk Reconciliation'
    },
    component: () => import('@ps_views/resources/Offers/BulkReconciliation/index.vue')
  },
  OFFER_CLICK_REPORT: {
    path: '/offer-click-report',
    name: 'offer_click_report',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/resources/Offers/ClickReport'),
    props: true
  },
  OFFER_MONTHLY_PACING: {
    path: '/offers/monthly-pacing',
    name: 'offer_monthly_pacing',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/resources/Offers/MonthlyPacing')
  },
  VARIOUS_REPORT: {
    path: '/various-report',
    name: 'various_report',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/resources/VariousReports')
  },
  COHORT_REPORT: {
    path: '/cohort-report',
    name: 'cohort_report',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/report/CohortReport.vue')
  },
  COHORT_REPORT_EXPORT: {
    type: 'function',
    path: 'cohort_report_export',
    name: 'cohort_report_export',
    permission: 'cohort_report_export',
    meta: {
      requiresAuth: true
    }
  },
  AFFILIATE_REPORT: {
    path: '/affiliate-report',
    name: 'affiliate_report',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/report/AffiliateReport.vue')
  },
  AFFILIATE_REPORT_EXPORT: {
    type: 'function',
    path: 'affiliate_report_export',
    name: 'affiliate_report_export',
    permission: 'affiliate_report_export',
    meta: {
      requiresAuth: true
    }
  },
  APP_ARTICLES: {
    path: '/app-articles',
    name: 'app_articles',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/chat/AppArticle')
  },
  DAILY_POLL: {
    path: '/daily-poll',
    name: 'daily_poll_manage',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/daily_poll')
  },
  OFFER_IAP_IMPORTS: {
    path: '/offer-iap-imports',
    name: 'offer_iap_imports',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/resources/Offers/IapImports')
  },
  OFFER_SUPPRESSION_IMPORTS: {
    path: '/offer-suppression-imports',
    name: 'offer_suppression_imports',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/resources/Offers/SuppressionImports')
  },
  OFFER_USER_IAP_DATA: {
    path: '/offer-user-iap-data',
    name: 'offer_user_iap_data',
    meta: {
      requiresAuth: true,
      quickLink: true,
      project: 'ps',
      models: ['offer', 'user'],
      title: 'IAP Data'
    },
    component: () => import('@ps_views/resources/Offers/UserIapData')
  },
  OFFER_PROVIDERS: {
    path: '/offer-providers',
    name: 'offer_providers',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/resources/Offers/Providers')
  },
  OFFER_REPORT: {
    path: '/offer-report',
    name: 'offer_report',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/resources/Offers/Report')
  },
  MONTHLY_REVENUE_REPORT: {
    path: '/monthly-revenue-report',
    name: 'monthly_revenue_report',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/resources/Offers/MonthlyRevenueReport')
  },
  FORSTA_MONTHLY_REPORT: {
    path: '/forsta-monthly-report',
    name: 'forsta_monthly_report',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/report/ForstaMonthlyReport.vue')
  },
  DISQO_MONTHLY_REPORT: {
    path: '/disqo-monthly-report',
    name: 'disqo_monthly_report',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/report/DisqoMonthlyReport.vue')
  },
  USER_OFFERS_OVERVIEW: {
    type: 'function',
    path: 'showUserOffersOverviewModal',
    name: 'user_offers_overview',
    permission: 'offer_events',
    meta: {
      requiresAuth: true,
      quickLink: true,
      project: 'ps',
      title: 'Offers Overview'
    }
  },
  OFFER_POSTBACK_LOGS: {
    path: '/offer-postback-logs',
    name: 'offer_postback_logs',
    meta: {
      requiresAuth: true,
      quickLink: true,
      project: 'ps',
      models: ['offer', 'user'],
      title: 'Offer Postback Logs'
    },
    component: () => import('@ps_views/resources/Offers/PostbackLogs')
  },
  POSTBACK_LOGS_EXPORT: {
    type: 'function',
    path: 'postback_logs_export',
    name: 'postback_logs_export',
    permission: 'postback_logs_export',
    meta: {
      requiresAuth: true
    }
  },
  POSTBACK_LOGS_RETRY: {
    type: 'function',
    path: 'postback_logs_retry',
    name: 'postback_logs_retry',
    permission: 'postback_logs_retry',
    meta: {
      requiresAuth: true
    }
  },
  OFFER_EVENT_REPORT: {
    path: '/offer-event-report',
    name: 'offer_event_report',
    meta: {
      requiresAuth: true,
      quickLink: true,
      project: 'ps',
      models: ['offer'],
      title: 'Event Analysis'
    },
    component: () => import('@ps_views/resources/Offers/Report/EventReport.vue')
  },
  EXCHANGE_RATE_ADJUSTMENT_REPORT: {
    path: '/exchange-rate-adjustment-report',
    name: 'exchange_rate_adjustment_report',
    meta: {
      requiresAuth: true,
      project: 'ps',
      models: ['offer'],
      title: 'Exchange Rate Adjustment Report'
    },
    component: () => import('@ps_views/resources/Offers/Report/ExchangeRateAdjustmentReport.vue')
  },
  DYNAMIC_CPI_REPORT: {
    path: '/dynamic-cpi-report',
    name: 'dynamic_cpi_report',
    meta: {
      requiresAuth: true,
      project: 'ps',
      models: ['offer'],
      title: 'Dynamic CPI Report'
    },
    component: () => import('@ps_views/resources/Offers/Report/DynamicCpiReport.vue')
  },
  OFFER_QUALITY_REPORT: {
    path: '/offer-quality-report',
    name: 'offer_quality_report',
    meta: {
      requiresAuth: true,
      quickLink: true,
      project: 'ps',
      models: ['offer'],
      title: 'Quality Report'
    },
    component: () => import('@ps_views/resources/Offers/Report/QualityReport.vue')
  },
  OFFER_PERFORMANCE_ANALYSIS: {
    path: '/offer-performance-analysis',
    name: 'offer_performance_analysis',
    meta: {
      requiresAuth: true,
      quickLink: true,
      project: 'ps',
      models: ['offer'],
      title: 'Performance Analysis'
    },
    component: () => import('@ps_views/resources/Offers/Report/PerformanceAnalysis.vue')
  },
  OFFER_PERFORMANCE_ANALYSIS_EXPORT: {
    type: 'function',
    path: 'offer_performance_analysis_export',
    name: 'offer_performance_analysis_export',
    permission: 'offer_performance_analysis_export',
    meta: {
      requiresAuth: true
    }
  },
  OFFER_USER_EXPORT: {
    path: '/offer-user-export',
    name: 'offer_user_export',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/resources/Offers/UserExport')
  },
  OFFER_CLIENTS: {
    path: '/offer-clients',
    name: 'offer_clients',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/resources/Offers/Clients')
  },
  OFFER_PACKAGES: {
    path: '/offer-packages',
    name: 'offer_packages',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/resources/Offers/Packages')
  },
  OFFER_CAP_REPORT: {
    path: '/offer-cap-report',
    name: 'offer_cap_report',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/resources/Offers/CapReport')
  },
  OFFER_CAP_REPORT_EXPORT: {
    type: 'function',
    path: 'offer_cap_report_export',
    name: 'offer_cap_report_export',
    permission: 'offer_cap_report_export',
    meta: {
      requiresAuth: true
    }
  },
  ADMIN_PERMISSION_GROUPS: {
    path: '/admin-permission-groups',
    name: 'admin_permission_groups',
    meta: {
      requiresAuth: true
    },
    component: () => import('@/views/AdminPermissionGroups/index.vue')
  },
  APP_PAIR_GROUPS: {
    path: '/app-pair-groups',
    name: 'app_pair_groups',
    meta: {
      requiresAuth: true
    },
    component: () => import('@/views/AppPairGroups/index.vue')
  },
  ADD_EDIT_APP_PAIR_GROUPS: {
    type: 'function',
    path: 'add-edit-app-pair-groups',
    name: 'add_edit_app_pair_groups',
    permission: 'add_edit_app_pair_groups',
    meta: {
      requiresAuth: true
    }
  },
  DELETE_APP_PAIR_GROUPS: {
    type: 'function',
    path: 'delete-app-pair-groups',
    name: 'delete_app_pair_groups',
    permission: 'delete_app_pair_groups',
    meta: {
      requiresAuth: true
    }
  },
  REVENUE_REPORT: {
    path: '/revenue-report',
    name: 'revenue_report',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/report/RevenueReport')
  },
  SUPPLIER_RECONCILIATIONS: {
    path: '/supplier-reconciliations',
    name: 'supplier_reconciliation_report',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/report/SupplierReconciliations.vue')
  },
  HORIZON_LOGIN: {
    path: '/horizon',
    name: 'horizon_login',
    permission: 'horizon_login',
    beforeEnter () {
      window.location.replace(`${process.env.VUE_APP_API_BASE_URL}/horizon-login`)
    }
  },
  TELESCOPE_AUTH: {
    type: 'function',
    path: 'telescope_auth',
    name: 'telescope_auth',
    permission: 'telescope_auth',
    meta: {
      requiresAuth: true
    }
  },
  CMS_LIST_APPS: {
    type: 'function',
    path: 'cms_list_apps',
    name: 'cms_list_apps',
    permission: 'cms_list_apps',
    meta: {
      requiresAuth: true
    }
  },
  CMS_MODIFY_APP: {
    type: 'function',
    path: 'cms_modify_app',
    name: 'cms_modify_app',
    permission: 'cms_modify_app',
    meta: {
      requiresAuth: true
    }
  },
  CMS_LIST_PAGES: {
    type: 'function',
    path: 'cms_list_pages',
    name: 'cms_list_pages',
    permission: 'cms_list_pages',
    meta: {
      requiresAuth: true
    }
  },
  CMS_MODIFY_PAGE: {
    type: 'function',
    path: 'cms_modify_page',
    name: 'cms_modify_page',
    permission: 'cms_modify_page',
    meta: {
      requiresAuth: true
    }
  },
  CMS_MODIFY_PAGE_COMPONENT: {
    type: 'function',
    path: 'cms_modify_page_component',
    name: 'cms_modify_page_component',
    permission: 'cms_modify_page_component',
    meta: {
      requiresAuth: true
    }
  },
  AI_CANDIDATE_EVALUATION: {
    path: '/ai-candidate-evaluation',
    name: 'ai_candidate_evaluation',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/resources/AiCandidateEvaluation')
  },
  AI_CANDIDATE_EVALUATION_DETAILS: {
    path: '/ai-candidate-evaluation/:evaluationRequestId/details',
    name: 'ai_candidate_evaluation_details',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/resources/AiCandidateEvaluation/Details.vue'),
    props: (route) => ({
      ...route.params
    })
  },
  LINKEDIN_TRACKED_PROFILES: {
    path: '/linkedin-tracked-profiles',
    name: 'profile_tracker',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/resources/LinkedinTrackedProfiles')
  },
  KNOWLEDGE_BASE_DOCUMENTS: {
    path: '/knowledge-base/documents',
    name: 'knowledge_base_documents',
    meta: {
      requiresAuth: true,
      title: 'Knowledge Base Documents'
    },
    component: () => import('@ps_views/resources/KnowledgeBase/index')
  },
  KNOWLEDGE_BASE_DOCUMENT_DETAIL: {
    path: '/knowledge-base/documents/:documentId',
    name: 'knowledge_base_document_detail',
    meta: {
      requiresAuth: true
    },
    component: () => import('@ps_views/resources/KnowledgeBase/index'),
    props: (route) => ({ ...route.params })
  }
}
